import { PartType } from '../constants/part-type.js';
import { isSellablePartType } from './is-sellable-part-type.js';
/** Every sellable part type, derived from `isSellablePartType` so a product filter cannot drift from the predicate. */
export const SELLABLE_PART_TYPE_IDS = Object.values(PartType)
    .filter((value) => typeof value === 'number')
    .filter((typeId) => isSellablePartType(typeId));
//# sourceMappingURL=sellable-part-type-ids.js.map